import { withSuspense } from "../../utils/withSuspense";

export const BlockUserModalLazy = withSuspense(
  () => import("./blockUserModal")
);
export const ChangePageTemplateModalLazy = withSuspense(
  () => import("./changePageTemplateModal")
);
export const ConfirmModalLazy = withSuspense(() => import("./confirmModal"));
export const CreateProjectModalLazy = withSuspense(
  () => import("./createProjectModal")
);
export const DeletePageFolderModalLazy = withSuspense(
  () => import("./deletePageFolderModal")
);
export const DeleteProjectModalLazy = withSuspense(
  () => import("./deleteProjectModal")
);
export const EditPremiumModalLazy = withSuspense(
  () => import("./editPremiumModal")
);
export const MigrateUserModalLazy = withSuspense(
  () => import("./migrateUserModal")
);
export const MoveModalLazy = withSuspense(
  () => import("./moveModal/MoveModal")
);
export const PublishModalLazy = withSuspense(
  () => import("./publishModal/publishModal")
);
export const QRModalLazy = withSuspense(() => import("./QRModal"));
export const RenameFolderModalLazy = withSuspense(
  () => import("./renameFolderModal/RenameFolderModal")
);
export const TemplateModalLazy = withSuspense(() => import("./templateModal"));
export const UpgradePlanModalLazy = withSuspense(
  () => import("./upgradePlanModal/upgradePlanModal")
);
export const PublishLimitModalLazy = withSuspense(
  () => import("./limit-modals/publish-limit-modal")
);
export const ProjectLimitModalLazy = withSuspense(
  () => import("./limit-modals/project-limit-modal")
);
export const UserEmailLogsModalLazy = withSuspense(
  () => import("../../pages/userAdministration/modal/UserEmailLogsModal")
);
